module.exports = __webpack_public_path__ + "img/dynamicLogo4.66ba4dac.png";